import { bulkLockTasks } from '@dispatch/shared/services';
import { BulkTaskLockResponse } from '@dispatch/shared/types';
import { useMutation, useQueryClient } from 'react-query';
import { invalidateTaskCaches } from './invalidateTaskCaches';

type BulkLockData = {
  taskIds: string[];
};

export function useBulkLockTasks(
  onSuccess?: (data: BulkTaskLockResponse) => void,
  onError?: () => void,
  onSettled?: () => void
) {
  const queryClient = useQueryClient();

  return useMutation(
    async (data: BulkLockData) => {
      const { taskIds } = data;
      return bulkLockTasks(taskIds);
    },
    {
      onSuccess,
      onError,
      onSettled: (_data, _error, variables) => {
        onSettled && onSettled?.();
        invalidateTaskCaches(queryClient, variables?.taskIds);
      },
    }
  );
}
